<script lang="ts">
	/** `/Products/:familySlug` while it loads: the tier headers across, the feature rows down. */
	import Bone from './Bone.svelte';

	export let tiers: number = 3;
	export let rows: number = 6;
</script>

<div role="status" aria-label="Loading the comparison" class="widget bg-depth animate-pulse overflow-hidden">
	<div class="grid gap-4" style="grid-template-columns: 12rem repeat({tiers}, minmax(0, 1fr));">
		<div />
		{#each Array(tiers) as _tier, index (index)}
			<div class="space-y-2 pb-4 border-t-4 border-gray-300 dark:border-gray-700 pt-3">
				<Bone class="h-4 w-2/3" />
				<Bone class="h-6 w-1/2" />
				<Bone class="h-8 w-full" round="xl" />
			</div>
		{/each}
		{#each Array(rows) as _row, rowIndex (rowIndex)}
			<Bone class="h-3 w-3/4" />
			{#each Array(tiers) as _cell, cellIndex (cellIndex)}
				<Bone class="h-3 w-1/3" />
			{/each}
		{/each}
	</div>
	<span class="sr-only">Loading…</span>
</div>
